import {
  asyncActionFinish,
  asyncActionError,
} from '../../../../App/common/reduxs/async/asyncActions';
import { ASYNC_ACTION_START } from '../../../../App/common/reduxs/async/asyncConstant';
import {
  SITE_ADDRESS,
  SITE_ADDRESS_PEMBELAJARAN,
} from '../../../../App/common/data/siteConfig';
import { checkRes, checkErr } from '../../../../App/common/helpers/checkRes';
import {
  activateEmailAuthUpdate,
  authLogout,
} from '../../../../App/login/redux/authAction';
import { closeModal } from '../../../../App/modals/redux/modalActions';
import { toastr } from 'react-redux-toastr';
import { emailUpdate } from './reduxAction';
import { activateEmailProfilUpdate } from '../../../profile/redux/reduxAction';

export const updatePassword = (auth, history, values) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'updatePassword' });
    const vusn = auth.vusn;
    const userId = auth.userId;
    const sessionId = auth.sessionId ? auth.sessionId : '';
    const deviceId = auth.deviceId ? auth.deviceId : '';
    const formData = new FormData();
    formData.append('vusn', vusn);
    formData.append('userId', userId);
    formData.append('sessionId', sessionId);
    formData.append('deviceId', deviceId);
    formData.append('oldPass', values.oldPass);
    formData.append('newPass', values.newPass);
    try {
      let fetchData = await fetch(SITE_ADDRESS + 'password/', {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: 'Bearer ' + auth.token,
        },
      });
      const response = await fetchData.json();
      const resultCheck = checkRes(response, fetchData, dispatch, 200, history);
      if (resultCheck) {
        toastr.error('Error', response.message);
        throw resultCheck;
      }
      const status = response.status;
      dispatch(asyncActionFinish());
      return status;
    } catch (error) {
      checkErr(error);
      dispatch(asyncActionError());
    }
  };
};

export const updateEmail = (auth, history, values) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'updateEmail' });
    const vusn = auth.vusn;
    const userId = auth.userId;
    const username = auth.username;
    const sessionId = auth.sessionId ? auth.sessionId : '';
    const deviceId = auth.deviceId ? auth.deviceId : '';
    const formData = new FormData();
    formData.append('vusn', vusn);
    formData.append('userId', userId);
    formData.append('username', username);
    formData.append('sessionId', sessionId);
    formData.append('deviceId', deviceId);
    formData.append('code', values.code);
    formData.append('email', values.email);
    formData.append('setAsUsername', values.setAsUsername);
    try {
      let fetchData = await fetch(
        SITE_ADDRESS_PEMBELAJARAN + 'email/update-email-recovery',
        {
          method: 'POST',
          body: formData,
          headers: {
            Authorization: 'Bearer ' + auth.token,
          },
        }
      );
      const response = await fetchData.json();
      const resultCheck = checkRes(response, fetchData, dispatch, 200, history);

      if (resultCheck) {
        if (response.message !== 'Email is already used!') {
          toastr.error('Error', response.message);
        }
        return response;
      }

      const res = {
        status: response.status,
        email: values.email,
        setAsUsername: values.setAsUsername,
        code: values.code,
      };
      dispatch(emailUpdate(res));
      dispatch(asyncActionFinish());
      return res;
    } catch (error) {
      checkErr(error);
      dispatch(asyncActionError());
    }
  };
};

export const resendUpdateEmail = (auth, history, values) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'updateEmail' });
    const vusn = auth.vusn;
    const userId = auth.userId;
    const username = auth.username;
    const sessionId = auth.sessionId ? auth.sessionId : '';
    const deviceId = auth.deviceId ? auth.deviceId : '';
    const formData = new FormData();
    formData.append('vusn', vusn);
    formData.append('userId', userId);
    formData.append('username', username);
    formData.append('sessionId', sessionId);
    formData.append('deviceId', deviceId);
    formData.append('code', values.code);
    formData.append('email', values.email);
    try {
      let fetchData = await fetch(
        SITE_ADDRESS_PEMBELAJARAN + 'email/update-email-recovery',
        {
          method: 'POST',
          body: formData,
          headers: {
            Authorization: 'Bearer ' + auth.token,
          },
        }
      );
      const response = await fetchData.json();
      const resultCheck = checkRes(response, fetchData, dispatch, 200, history);
      if (resultCheck) {
        toastr.error('Error', response.message);
        throw resultCheck;
      }
      const res = {
        status: response.status,
        email: values.email,
        setAsUsername: values.setAsUsername,
        code: values.code,
      };
      dispatch(emailUpdate(res));
      dispatch(asyncActionFinish());
      return res;
    } catch (error) {
      checkErr(error);
      dispatch(asyncActionError());
    }
  };
};

export const resetEmailRec = (auth, history, values) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'resetEmailRec' });
    try {
      dispatch(
        emailUpdate({ status: '', email: '', setAsUsername: false, code: '' })
      );
      dispatch(asyncActionFinish());
    } catch (error) {
      checkErr(error);
      dispatch(asyncActionError());
    }
  };
};

export const activationCode = (auth, history, values, emailRec, sprofil) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'activationCode' });
    console.log(emailRec.code, values.code);

    if (emailRec.code !== values.code) {
      return toastr.error('Error', 'Kode yang diinputkan salah.');
    }
    const vusn = auth.vusn;
    const userId = auth.userId;
    const username = auth.username;
    const sessionId = auth.sessionId ? auth.sessionId : '';
    const deviceId = auth.deviceId ? auth.deviceId : '';
    const formData = new FormData();
    formData.append('vusn', vusn);
    formData.append('userId', userId);
    formData.append('username', username);
    formData.append('sessionId', sessionId);
    formData.append('deviceId', deviceId);
    formData.append('email', emailRec.email);
    formData.append('setAsUsername', emailRec.setAsUsername);
    try {
      let fetchData = await fetch(
        SITE_ADDRESS_PEMBELAJARAN + 'email/activate-email',
        {
          method: 'POST',
          body: formData,
          headers: {
            Authorization: 'Bearer ' + auth.token,
          },
        }
      );
      const response = await fetchData.json();
      const resultCheck = checkRes(response, fetchData, dispatch, 201, history);
      if (resultCheck) {
        toastr.error('Error', response.message);
        throw resultCheck;
      }
      const status = response.status;
      const portaluser = response.portaluser;
      dispatch(
        emailUpdate({ status: '', email: '', setAsUsername: false, code: '' })
      );
      dispatch(activateEmailAuthUpdate({ username: portaluser?.username }));
      dispatch(activateEmailProfilUpdate({ username: portaluser?.username }));
      dispatch(asyncActionFinish());
      return status;
    } catch (error) {
      checkErr(error);
      dispatch(asyncActionError());
    }
  };
};

export const deleteAccount = (auth, history) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'deleteAccount' });
    const vusn = auth.vusn;
    const userId = auth.userId;
    const sessionId = auth.sessionId ? auth.sessionId : '';
    const deviceId = auth.deviceId ? auth.deviceId : '';
    const formData = new FormData();
    formData.append('vusn', vusn);
    formData.append('userId', userId);
    formData.append('sessionId', sessionId);
    formData.append('deviceId', deviceId);
    try {
      let fetchData = await fetch(SITE_ADDRESS + 'delete-account/', {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: 'Bearer ' + auth.token,
        },
      });
      const response = await fetchData.json();
      const resultCheck = checkRes(response, fetchData, dispatch, 201, history);
      if (resultCheck) {
        throw resultCheck;
      }
      history.push('/');
      dispatch(authLogout());
      dispatch(closeModal());
      dispatch(asyncActionFinish());
    } catch (error) {
      checkErr(error);
      dispatch(asyncActionError());
    }
  };
};
